import { useEffect, useState } from 'react';

const getToday = () => new Date().setHours(0, 0, 0, 0);

export const useToday = () => {
  const [today, setToday] = useState(getToday);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    const scheduleNextMidnight = () => {
      const now = new Date();

      const nextMidnight = new Date(now);
      nextMidnight.setDate(nextMidnight.getDate() + 1);
      nextMidnight.setHours(0, 0, 0, 0);

      timeout = setTimeout(() => {
        setToday(getToday());
        scheduleNextMidnight();
      }, nextMidnight.getTime() - now.getTime());
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        clearTimeout(timeout);

        setToday(getToday());
        scheduleNextMidnight();
      }
    };

    scheduleNextMidnight();

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeout(timeout);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return today;
};
